import PropTypes from 'prop-types';
export default PropTypes.shape({
    accessToken: PropTypes.string.isRequired,
    expiresIn: PropTypes.number.isRequired,
    tokenType: PropTypes.oneOf([
        'Bearer'
    ]).isRequired
});
